// @flow
import { RESORT_INTRODUCTION } from 'Client/cms/toolkit/constants';
import { ProductIntroductionLine } from 'Components/lines/product-introduction-line/ProductIntroductionLine.jsx';
import { productIntroductionResolver } from './productIntroduction.resolver';

export const productIntroductionDescriptor = {
  name: RESORT_INTRODUCTION,
  component: ProductIntroductionLine,
  resolve: productIntroductionResolver.resolve,
};
